module.exports = __webpack_public_path__ + "static/media/apple-music.f3596758.svg";